<template lang="pug">
  
  v-card.task(
    :color="item.category ? item.category.color : 'primary'"
    :class="classObject"
    :data-info="item.toString()"
    @click.stop="$emit('click', $event)"
  )
    .content
      //- .client(v-if="item.client") {{ item.starts_at | moment('YY-MM-DD H:mm') }}-{{ item.ends_at | moment('H:mm') }} {{ item.client.name }}
      .client(v-if="item.client") {{ item.client.name }}
      .description {{ item.title }}
    .owner(v-if="item.owner") {{ item.owner.name }}
    .icons(v-if="item.url || item.path")
      v-tooltip(v-if="item.path" top)
        template(v-slot:activator="{ on }")
          v-btn.path(text icon small @click.stop="copyPath(item.path)" target="_blank" v-on="on"): v-icon(small) mdi-folder-network
        span {{ item.path }}
      v-tooltip(v-if="item.url" top)
        template(v-slot:activator="{ on }")
          v-btn.url(text icon small @click.stop="" :href="item.url" target="_blank" v-on="on"): v-icon(small) mdi-link-variant
        span {{ item.url }}

</template>

<script>
import cellable from './mixins/cellable'
import { copyTextToClipboard } from 'w3box-utils'

export default{
  
  mixins: [cellable],

  methods: {
    copyPath(path) {
      copyTextToClipboard(path)
      this.$store.dispatch('notify', { text: this.$t('ui.copied_to_clipbard') })
    }
  },
}
</script>